import React from "react";
import styleSheet from "./style.module.scss";
// import { fileDat } from "../files-comments-manage/file-comment-config";
import SyIcon from "../../../../shared/components/sy-icon";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import SyTooltip from "../../../../shared/components/sy-tooltip";
import { useSelector } from "react-redux";
import { getAuthDetails } from "../../../../feature/auth-slice";
import { getOrbitDetails } from "../../../../feature/orbit-slice";

type Props = {};

function FilesList(prop: any) {
  const {fileData,deleteDoc} = prop
  const { t } = useTranslation();
  const authSlice = useSelector(getAuthDetails);
  const orbitSlice = useSelector(getOrbitDetails);
  const openDoc =(url:any)=>{
    window.open(url, `_blank`);
  }
    const getTime = (time: any) => {
      return dayjs(time).format("HH:mm");
      
    };
  const getTableRow = (data: any) =>
    data?.map((data: any, index: number) => (
      <tr key={index} className="lh-lg">
           <SyTooltip title={data.odf_file_name}>
        <td className={`small-font text-center pointer ellipsis`}>
         
          <SyIcon name="description" className={"top-50 sub-font d-flex justify-content-center align-self-center"} iconStyle="outlined" iconType="symbols" onClick={()=>openDoc(data.doc_image)} />
         
        </td>
        </SyTooltip>
        
        <td className={`small-font ellipsis`}>{data.usr_name}</td>
        <td className={`small-font ellipsis ${styleSheet.muted_td}`}>{data.date}</td>
        <td className={`small-font ellipsis ${styleSheet.muted_td}`}>{getTime(data.created_at)} Uhr</td>
        <td className={`small-font ellipsis text-center `}>{data.file_size}</td>
        <td className={`small-font ellipsis text-center pointer`}>
          {data.usr_id === authSlice.user_details.usr_id?(
          <SyIcon name="delete" className={"top-50 sub-font d-flex justify-content-center align-self-center"} iconStyle="outlined" iconType="symbols" onClick={()=>deleteDoc(data)} />
          ):null}
        </td>
        
      </tr>
    ));

  return (
    <table className={` ${styleSheet.table_style} w-100`}>
      <thead className="lh-lg">
        <tr>
          <th className="sub-font text-center ellipsis col-1" scope="col">
            {t('art')}
          </th>
          <th className="sub-font col-3 ellipsis" scope="col">
          {t('upload_by')}
          </th>
          <th className="sub-font col-2 ellipsis" scope="col">
            {t('date')}
          </th>
          <th className="sub-font col-2 ellipsis" scope="col">
          {t('time')}
          </th>
          <th className="sub-font text-center ellipsis col-2" scope="col">
          {t('size')}
          </th>
          <th className="sub-font text-center ellipsis col-2" scope="col">
          {t('action')}
          </th>
        </tr>
      </thead>
      <tbody>{getTableRow(fileData)}</tbody>
      {!fileData.length && (
          <div className=" position-absolute top-50 start-50 translate-middle  mohave text-white  ">
            <p className="">{t("no_data_found")}</p>
          </div>
        )}
    </table>
  );
}

export default FilesList;
